import React, { useState } from "react";
import Modal from "../shared/Modal";

import "./ModalCreatePolicyProject.css";

import ActionButton from "../common/ActionButton";
import { Button } from "../../ds2/components";

interface ModalConfirmEmbedPolicyAsResourceProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (replaceExisting: boolean) => void;
}

export const ModalConfirmEmbedPolicyAsResource: React.FC<
  ModalConfirmEmbedPolicyAsResourceProps
> = ({ isOpen, onClose, onSubmit }) => {
  const [replaceExisting, setReplaceExisting] = useState(false);

  const handleSubmit = () => {
    onSubmit(replaceExisting);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{
        width: "500px",
      }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="modal-create-policy-project">
        <div className="modal-create-policy-project-title">
          <h2>Would you like to replace the existing resource?</h2>
        </div>
        <div className="modal-create-policy-project-body">
          <div className="modal-create-policy-project-content">
            <div className="modal-create-policy-project-replace-toggle">
              <input
                title="Replace existing policy?"
                type="checkbox"
                checked={replaceExisting}
                onChange={(e) => setReplaceExisting(e.target.checked)}
              />
              Replace existing policy?
            </div>
          </div>
        </div>
        <div className="modal-create-policy-project-buttons">
          <Button label="Cancel" variant="primary" onClick={onClose} />
          <Button
            label="Confirm"
            variant="tertiary"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};
